<template>
  <VueJsModalPrimary
    v-bind="{ ...attrs.modal, ...$attrs }"
    v-on="$listeners"
    @before-close="beforeClose"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <HeaderLargePrimary>
        Survey Complete
      </HeaderLargePrimary>
      <CardAttention :style="style.card">
        <HeaderMediumAttention :style="style.headerAttention">
          Congratulations!
        </HeaderMediumAttention>
        <div :style="style.textAttention">
          You have successfully completed "{{ survey.name }}".
        </div>
      </CardAttention>
      <HeaderMediumPrimary :style="style.headerMedium">
        Finish up your skills graph
      </HeaderMediumPrimary>
      <TextRegular>
        Your skills graph can contain free-form skills and allow you to link relevant skills.
      </TextRegular>
      <div :style="style.footer">
        <TextButtonMuted @click="goToHomePage">
          Maybe later
        </TextButtonMuted>
        <ButtonPrimary
          @click="goToUserPage"
          :style="style.buttonPrimary"
        >
          Let's do it
        </ButtonPrimary>
      </div>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import CardAttention from '@modules/v2/card/card-attention'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import HeaderMediumAttention from '@modules/v2/header/header-medium-attention'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import TextButtonMuted from '@modules/v2/button/text-button-muted'
  import TextRegular from '@modules/v2/text/text-regular'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalSurveyWrapUpPrimary',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      CardAttention,
      HeaderLargePrimary,
      HeaderMediumAttention,
      HeaderMediumPrimary,
      TextButtonMuted,
      TextRegular,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        name: MODAL_WINDOW_NAMES.WRAP_UP_SURVEY_PRIMARY,
        survey: {},
        attrs: {
          modal: {
            height: 'auto',
            maxWidth: 480,
            width: '90%',
          },
        },
        style: {
          buttonPrimary: {
            margin: `0 0 0 ${Layout.space.md}`,
          },
          card: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            margin: `${Layout.space.xl} 0`,
            padding: Layout.space.md,
            width: '100%',
          },
          container: {
            padding: Layout.space.lg,
          },
          footer: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'flex-end',
            margin: `${Layout.space.xl} 0 0 0`,
            width: '100%',
          },
          headerAttention: {
            margin: `0 0 ${Layout.space.md} 0`,
          },
          headerMedium: {
            margin: `0 0 ${Layout.space.sm} 0`,
          },
          textAttention: {},
        },
      };
    },
    created: function () {
      this.attrs.modal.name = this.name;
      this.style.card.color = this.color.overlayBorder1();
      this.style.textAttention.color = this.color.overlayBorder1();
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapState({
        tenantUser: state => state.tenantUser,
      }),
    },
    methods: {
      beforeClose: function () {
        this.clearCache();
      },
      beforeOpen: function (e) {
        this.clearCache();

        this.survey = e?.params?.survey;
        if (!this.survey) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to load survey data',
          );
          this.close();
        }
      },
      clearCache: function () {
        this.survey = {};
      },
      close: function () {
        this.clearCache();
        this.$modal.hide(this.name);
      },
      goToHomePage: function () {
        this.$router.push({
          name: 'private-home',
        });
      },
      goToUserPage: function () {
        this.$router.push({
          name: 'user',
          params: {
            id: this.tenantUser.id,
          },
        });
      },
    },
  };
</script>
